import type { AccessRoleCode } from "Models/AccessRoleCodes";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

/**
 * Mirrors the backend author admission (StoryAuthorAdmission): Admin always, Merchant only while
 * merchant authoring is switched on. The first stories release is brand-only — Mo.one posts,
 * customers consume — so the merchant side ships dark. This build flag only drives VISIBILITY
 * (menu links, routes, the dashboard plus badge); the backend setting
 * `Stream.IsMerchantStoryAuthoringEnabled` is what is enforced, and when the two disagree the
 * backend wins and a merchant sees a forbidden error instead of a hole.
 */
export const IS_MERCHANT_STORY_AUTHORING_ENABLED =
  import.meta.env.VITE_STORIES_MERCHANT_AUTHORING_IS_ENABLED === "true";

export const STORY_AUTHOR_ROLES: ReadonlyArray<AccessRoleCode> =
  IS_MERCHANT_STORY_AUTHORING_ENABLED
    ? [AccessRoleCodes.Admin, AccessRoleCodes.Merchant]
    : [AccessRoleCodes.Admin];

export const canAuthorStories = (role: AccessRoleCode | null | undefined) =>
  role != null && STORY_AUTHOR_ROLES.includes(role);
